import { ReactComponent as FxIcon } from './fxIcon.svg';

export default FxIcon;
